/*
 * @Description:
 * @Author: fal
 * @Date: 2025-07-18 17:02:07
 * @FilePath: \xhlz_pc\src\router\index.js
 * @LastEditTime: 2025-08-27 14:22:11
 */
import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter);
import newroutes from '../project/router/index.js';
import { adminRoutes } from './admin.js';
const routes = [
  ...newroutes,
  {
    path: '/administrator',
    component: () => import('@/administrator/index'),
    name: 'administrator',
  },
  // 平台
  {
    path: '/admin/login',
    name: 'adminLogin',
    component: () => import('@/views/login/login'),
    meta: {
      title: '登录',
    },
  },
  {
    path: '/main',
    meta: {
      title: '主界面',
    },
    component: () => import('@/views/main/layout.vue'),
    redirect: '/admin/dashboard',
    children: [...adminRoutes],
  },
];
const router = new VueRouter({
  mode: 'hash',
  routes,
});

router.beforeEach((to, from, next) => {
  // 保存页面参数，刷新或返回页面时使用
  const hasRealParams = to.params && Object.keys(to.params).length;
  if (hasRealParams) {
    window.sessionStorage.setItem(to.name, JSON.stringify(to.params));
  }
  next();
});

// 屏蔽router push相同url时console报错
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

export default router;
